import { render, staticRenderFns } from "./Login_old.vue?vue&type=template&id=255a3bbd&scoped=true"
import script from "./Login_old.vue?vue&type=script&lang=js"
export * from "./Login_old.vue?vue&type=script&lang=js"
import style0 from "./Login_old.vue?vue&type=style&index=0&id=255a3bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a3bbd",
  null
  
)

export default component.exports